module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/spot_04@2x-d5217ab88baa21b04352367dc88bb518.webp";